export const COLORS = {
    PRIMARY: '#4EAC6D',
    PRIMARY_LIGHT: '#A0D9B3',
    SUCCESS: {
        background: '#E8F5E9',
        border: '#C8E6C9',
        text: '#2E7D32',
    },
    WARNING: {
        background: '#FFF9E6',
        border: '#FFD54F',
        text: '#F57C00',
    },
    ERROR: {
        background: '#FFEBEE',
        border: '#EF9A9A',
        text: '#C62828',
    },
    INFO: {
        background: '#E3F2FD',
        border: '#90CAF9',
        text: '#1565C0',
    },
}

export const SELECTOR_STYLE = {
    control: (provided, state) => ({
        ...provided,
        width: '100%',
        minHeight: '44px',
        padding: '0 12px',
        borderColor: state.isFocused ? COLORS.PRIMARY : '#e0e0e0',
        borderWidth: '1px',
        borderRadius: '8px',
        fontSize: '14px',
        fontWeight: 'normal',
        backgroundColor: '#ffffff',
        boxShadow: state.isFocused ? '0 0 0 2px rgba(78, 172, 109, 0.1)' : 'none',
        '&:hover': {
            borderColor: '#4eac6d',
        },
        transition: 'all 0.2s ease',
    }),
    valueContainer: provided => ({
        ...provided,
        padding: '2px 4px',
        minHeight: '42px',
    }),
    input: provided => ({
        ...provided,
        margin: '0',
        padding: '0',
    }),
    singleValue: provided => ({
        ...provided,
        color: '#333',
        margin: '0',
    }),
    placeholder: provided => ({
        ...provided,
        color: '#999',
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor:
            state.isSelected ?
                COLORS.PRIMARY
                // : state.isFocused ? COLORS.PRIMARY_LIGHT
            :   'white',
        color:
            state.isDisabled ? '#ccc'
            : state.isSelected ? 'white'
            : '#333',
        cursor: state.isDisabled ? 'not-allowed' : 'pointer',
        fontSize: '14px',
        padding: '12px 16px',
        transition: 'all 0.2s ease',
        '&:hover': {
            backgroundColor: state.isDisabled ? 'white' : COLORS.PRIMARY_LIGHT,
        },
    }),
    // singleValue: (provided) => ({
    //   ...provided,
    //   color: COLORS.PRIMARY,
    // }),
    multiValue: provided => ({
        ...provided,
        backgroundColor: COLORS.PRIMARY,
    }),
    multiValueLabel: provided => ({
        ...provided,
        color: 'white',
        fontSize: '16px',
        backgroundColor: COLORS.PRIMARY,
        width: 'auto',
    }),
    multiValueRemove: provided => ({
        ...provided,
        color: 'white',
    }),
    indicatorSeparator: () => ({
        display: 'none',
    }),
    dropdownIndicator: (provided, state) => ({
        ...provided,
        color: state.isFocused ? COLORS.PRIMARY : provided.color,
        '&:hover': { color: COLORS.PRIMARY },
    }),
    menu: provided => ({
        ...provided,
        borderRadius: '8px',
        border: '1px solid #e0e0e0',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
    }),
    menuList: provided => ({
        ...provided,
        padding: '4px',
    }),
}
